import aboutActions from './about'
import eventsActions from './events'
import webinarsActions from './webinars'
import accountsActions from './accounts'
import financialClubsActions from './financialClubs'
import documentsActions from './documents'
import requisitesActions from './requisites'
import newsActions from './news'
import disclosureInformationActions from './disclosureInformation'
import normativeActsActions from './normativeActs'
import requiredInformationActions from './requiredInformation'
import brokerInformationActions from './brokerInformation'
import serviceRequestsActions from './serviceRequests'
import dataForClientsActions from './dataForClients'
import additionalPagesActions from './pages'
import departmentsActions from './departments'
import publicationsActions from './publications'
import partnersActions from './partners'
import historyActions from './history'
import investmentActions from './individualInvestment'
import loanActions from './bondedLoan'
import investorActions from './investor'
import redirectsActions from './redirects'
import metaTagsActions from './metaTags'
import financialClubInfoActions from './financialClubInfo'

export default {
  ...newsActions,
  ...aboutActions,
  ...eventsActions,
  ...historyActions,
  ...partnersActions,
  ...webinarsActions,
  ...accountsActions,
  ...documentsActions,
  ...departmentsActions,
  ...publicationsActions,
  ...normativeActsActions,
  ...financialClubsActions,
  ...dataForClientsActions,
  ...serviceRequestsActions,
  ...requiredInformationActions,
  ...additionalPagesActions,
  ...disclosureInformationActions,
  ...brokerInformationActions,
  ...requisitesActions,
  ...investmentActions,
  ...loanActions,
  ...investorActions,
  ...redirectsActions,
  ...metaTagsActions,
  ...financialClubInfoActions
}



// WEBPACK FOOTER //
// ./src/store/actions/index.js